import { createBrowserRouter, RouterProvider } from "react-router-dom";
import "./App.css";
import RootLayout from "./pages/root";
import { ThemeProvider, createTheme } from "@mui/material/styles";

//*************** Pages Import ************************/
import Home from "./pages/home";
import Login from "./pages/login";
import SignUp from "./pages/signup";
import Product from "./pages/product";
import Account from "./pages/account";
import AuthValidate from "./pages/auth-validate";
import Activate from "./pages/activate";
import ForgotPassword from "./pages/forgotpassword";
import ResetPassword from "./pages/resetpassword";
import PaymentSuccess from "./pages/success";

const theme = createTheme({
  palette: {
    primary: {
      light: "#FFF2CD",
      main: "#F47907",
    },
    secondary: {
      light: "#DD6D06",
      main: "#FF8D24",
    },
  },
  typography: {
    // // Disable subtitle1 variant
    h6: { color: "#3A3A3A" },
    // Disable subtitle2 variant
    subtitle2: { fontSize: ".7rem", color: "#0B0800" },
    // Disable subtitle2 variant
    body1: { fontSize: "14px", color: "#8D8D8D", fontWeight: 400 },
    body2: { fontSize: "12px", color: "#E8E8EA", fontWeight: 400 },
  },
  components: {
    MuiOutlinedInput: {
      styleOverrides: {
        // Name of the slot
        root: {
          // Some CSS
          fontSize: ".76rem",
          color: "#3A3A3A",
          // padding: '6.5px 12px',
          height: "2.9em",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        // Name of the slot
        root: {
          // Some CSS
          fontSize: ".7rem",
          color: "#ffff",
          textTransform: "initial",
          "&.Mui-disabled": {
            backgroundColor: "#C1C1C1",
            // border: "none"
            color: "white",
          },
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        // Name of the slot
        root: {
          // Some CSS
          "&.Mui-disabled": {
            backgroundColor: "#C1C1C1",
            border: "none",
            color: "white",
          },
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        // Name of the slot
        root: {
          // Some CSS
          color: "#C1C1C1",
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        // Name of the slot
        root: {
          // Some CSS
          fontSize: "12px",
          textTransform: "initial",
          color: "#8D8D8D",
          "&.Mui-selected": {
            color: "#3A3A3A",
          },
          "&.Mui-disabled": {
            color: "#dfdfdf",
            cursor: "not-allowed"
          },
        },
      },
    },
    MuiListItem: {
      styleOverrides: {
        root: {
          // Some CSS
          color: "#0B0800",
          fontSize: "14",
          fontWeight: 400,
          borderRadius: "5px 0px 0px 5px",
          "&.Mui-selected": {
            // fontSize: ".9rem",
            backgroundColor: "#FFF2CD",
            "& .MuiSvgIcon-root": {
              // color: '#F47907',
            },
            "& .MuiListItemText-root .MuiTypography-root": {
              color: "#F47907",
            },
          },
        },
      },
    },
    MuiAccordion: {
      styleOverrides: {
        // Name of the slot
        root: {
          color: "#8D8D8D",
          "&.Mui-expanded": {
            minHeight: "55px",
            borderBottom: "1px solid #E8E8EA",
            marginBottom: "15px !important",
            color: "#3A3A3A"
            // margin: "15px 0"
          }
        },
      },
    },
    MuiFormHelperText: {
      styleOverrides: {
        // Name of the slot
        root: {
          "&.Mui-error":{
            color: "#FF0606",
          }        
        },
      },

    }

  },
});

const router = createBrowserRouter([
  {
    element: <AuthValidate />,
    children: [
      {
        element: <RootLayout />,
        path: "/",
        children: [
          { index:true,element: <Home /> },
          { path: "/products",element: <Home /> },
          { path: "/products/:id", element: <Product /> },
          { path: "/products/:id/:categoryId", element: <Product /> },
          { path: "/account", element: <Account /> },
          { path: "/success", element: <PaymentSuccess /> },
        ]
      }
      
    ],
  },
  { path: "/login", element: <Login /> },
  { path: "/signup", element: <SignUp /> },
  { path: "/activate", element: <Activate /> },
  { path: "/forgotpassword", element: <ForgotPassword /> },
  { path: "/resetpassword", element: <ResetPassword /> },
  { path: "/resetpassword", element: <ResetPassword /> },
  
]);

function App() {
  return (
    <ThemeProvider theme={theme}>
      <RouterProvider router={router} />
    </ThemeProvider>
  );
}

export default App;
